//@flow
import * as React from 'react';
import * as Immutable from 'immutable';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { clientIdSelector } from 'common/redux/selectors/sessionSelector';

import { Shift } from 'common/models/flow/Shift';
import { ShiftId } from 'common/models/internal/ShiftId';

import { translate } from 'react-i18next';
import debounce from 'lodash/debounce';
import { bulkShiftFetch as bulkShiftFetchApi } from 'common/middleware/api';

import EntityIdInput from 'common/entity/generic/EntityIdInput';

type Props = {
    disabled: boolean,
    isLoading: boolean,
    clientId: string,
    shift: ?Shift,
    theme: Object,
    field: Object,
    getShiftFilters: (input: string) => Object,
    onChange: (?ShiftId) => void,
    t: (string, ?Object) => string
};

type State = {
    shifts: Array<ShiftId>
};

class ShiftIdInput extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        this.state = {
            shifts: []
        };
        this.loadOptions = debounce(this.loadOptions, 200);
    }

    loadOptions = (input: string, callback) => {
        const { clientId, getShiftFilters } = this.props;
        const filters = getShiftFilters(input);
        bulkShiftFetchApi
            .post({ clientId }, { filters })
            .then((response: Object) => {
                const { shifts } = response;
                this.setState({ shifts });
                callback(shifts);
            })
            .catch(() => {
                //Ignore the error
            });
    };

    onChange = values => {
        const { onChange, clientId } = this.props;
        let shiftIds = [];
        if (values?.length) {
            shiftIds = values.map(value =>
                ShiftId.fromJS({
                    clientId,
                    shiftId: value.id,
                    version: value.version
                })
            );
        }
        onChange && onChange(Immutable.List(shiftIds));
    };

    render() {
        const { shifts } = this.state;
        const { shift, field, t, ...rest } = this.props;
        const { placeholder } = field;
        return (
            <EntityIdInput
                {...rest}
                isMulti
                onChange={this.onChange}
                options={shifts}
                value={shift}
                placeholder={t(placeholder)}
                loadOptions={this.loadOptions}
            />
        );
    }
}

const mapStateToProps = (state, props) => {
    const clientId = clientIdSelector(state, props);
    return {
        clientId
    };
};

const withRedux = connect(mapStateToProps);
export default compose(withRedux, translate('entityManagement'))(ShiftIdInput);
